export default __webpack_public_path__ + "static/media/Van23.00eaa31b.webp";